<nav-bar [isCircle]="true"> </nav-bar>

<div *ngIf="showImport" class="container-import">
  <div class="import">
    <div class="header-content">
      <div class="title">
        <h3>Import {{ currentModule | titlecase }}</h3>
      </div>
    </div>
    <div class="content-import">
      <div class="download-btn">
        <a [href]="guidelinesModule?.exampleFile" download="template.csv"
          >Download .CSV Template</a
        >
      </div>
      <form
        action=""
        [formGroup]="uploadForm"
        #form="ngForm"
        (ngSubmit)="save()"
        novalidate
        class="upload-form"
      >
        <div *ngIf="!progressBarPopup" class="upload-file-content">
          <div class="d-block">
            <div *ngIf="!isUploaded" (click)="fetchFile()" class="upload-file">
              <input
                type="file"
                [allowedExt]="photoAllowedExt"
                #attachedFile
                [accept]="photoAllowedExt"
                (change)="uploadImage($event)"
                formControlName="records"
                [hidden]="true"
              />
              <div class="icon">
                <img src="./assets/images/plus-circle-dotted.svg" alt="" />
              </div>
              <span>Choose File To Upload</span>
            </div>
            <div *ngIf="isUploaded" class="file-info upload-file">
              <div class="file-name">{{ fileName }}</div>
              <!-- <div class="hide-show-file"><img src="./assets/images/eye.svg" alt="eye"></div> -->
              <div
                class="remove-file"
                (click)="deleteFile()"
                style="cursor: pointer"
              >
                <img src="./assets/images/trash2-fill.svg" alt="" />
              </div>
            </div>
          </div>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="uploadForm.controls['records']"
          >
          </app-form-errors>
        </div>

        <div *ngIf="progressBarPopup" class="progress-bar-popup">
          <p class="content">
            Your CSV file has been successfully uploaded.
            <span
              >We are now processing the records. Please wait while we add them
              to the database.</span
            >
            <span class="cancel-queue" (click)="messageComponent.open()"
              >Cancel Import</span
            >
          </p>
          <div class="progress-bar">
            <p-progressBar [value]="progressBarInfo?.value"></p-progressBar>
          </div>
        </div>

        <div *ngIf="currentModule === 'fortegra-claims'" class="fortegra-options" style="display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <p-inputSwitch formControlName="is_fortegra_claim"></p-inputSwitch>
            <label class="form-label" style="margin: 0;">Is Fortegra Claim</label>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <p-inputSwitch formControlName="is_uploaded_fortegra_claim"></p-inputSwitch>
            <label class="form-label" style="margin: 0;">Is Uploaded Fortegra Claim If this flag is checked the claim adjustments will not be applied to claim amount</label>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <label class="form-label" style="margin: 0; min-width: 100px;">Amount Mode</label>
            <p-dropdown
              formControlName="amount_mode"
              [options]="amountModeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select amount mode"
              styleClass="w-full md:w-14rem"
            ></p-dropdown>
          </div>
        </div>

        <div class="guidelines-container">
          <h2 class="title">Guide For Importing {{ currentModule }}</h2>
          <div class="sub-title">{{ guidelinesModule?.guides?.title }}</div>
          <ul>
            <li *ngFor="let guide of guidelinesModule?.guides?.content">
              {{ guide }}
            </li>
          </ul>
        </div>

        <div class="footer-form">
          <button
            class="cancel-btn"
            type="button"
            [disabled]="loadingSubmit"
            (click)="back()"
          >
            Back
          </button>
          <button
            *ngIf="!progressBarPopup"
            [disabled]="loadingSubmit"
            type="submit"
            class="create-btn custom-btn"
          >
            Import Now
            <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- confirmation message -->
<app-confirmation-msg
  #messageComponent
  [isLoading]="loadingSubmit"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="
    'Do you want to cancel import ' + progressBarInfo?.module + ' module?'
  "
>
</app-confirmation-msg>
